module.exports = __webpack_public_path__ + "static/media/lollorossa.d9d86ccb.webp";